import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntSkeletonComponent } from "./int-skeleton.component";


@NgModule({
  declarations: [
    IntSkeletonComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    IntSkeletonComponent
  ]
})
export class IntSkeletonModule { }
